import React from 'react';

const SavedPaymentMethodButton = ({ onClick, label }) => (
  <button className="custom-button" id={`pay-with-custom-btn-saved-card`} onClick={onClick} >
    Saved { label }s
  </button>
)

export default SavedPaymentMethodButton;
